import { Component, EventEmitter, inject, Inject, Input, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject, catchError, distinctUntilChanged, map, Observable, of, startWith, Subject, switchMap } from 'rxjs';
import { Verification } from '../../../services/verification';
import { DataState } from '../../../model/dataState';
import { Country } from 'country-state-city';
import { Router } from '@angular/router';
import { VerificationPatchService } from '../../../services/verification-patch-service';

interface queryParams {
  country: string,
  companyName: string,
  easyNumber: string,
  page: number,
  size: number,
  type: string
}
@Component({
  selector: 'app-canon-search-dialog',
  standalone: false,
  templateUrl: './canon-search-dialog.html',
  styleUrl: './canon-search-dialog.less',
})
export class CanonSearchDialog {
  targetCompanyName: string = '';
  @Output() onClose = new EventEmitter<void>();
  @Output() createRequest = new EventEmitter<any>();
  @Output() mapToRecord = new EventEmitter<any>();
  private verificationTransferService = inject(VerificationPatchService);
  queryParameters$ = new BehaviorSubject<queryParams>({ country: '', companyName: '', easyNumber: '', type: '', page: 0, size: 100 })
  countryList = Country.getAllCountries();
  private verificationService = inject(Verification);
  private router = inject(Router);
  searchQuery: string = '';
  selectedRecord: any = {};
  canonList$!: Observable<DataState<any[]>>;
  private destroy$ = new Subject<void>();
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<CanonSearchDialog>) {
    console.log(this.data);
    this.targetCompanyName = this.data?.record.companyName;
    console.log(this.targetCompanyName)
  }
  ngOnInit(): void {
    this.canonList$ = this.queryParameters$.pipe(
      switchMap((params: queryParams) => {
        return this.getCanonList(params.page, params.size, params.companyName, params.easyNumber, params.type, params.country);
      })
    );
  }

  trackByRecordId(index: number, record: any): string | number {
    return record.id; // Or whatever your primary key property is named
  }

  getCanonList(rowNum: number, size: number, companyName: string = '', easyNumber: string = '', type: string = '', country: string = '') {
    return this.verificationService.getCanonList(rowNum, size, companyName, easyNumber, type, country)
      .pipe(
        map((response: any) => ({
          loading: false,
          error: null,
          data: response?.result
        })),
        catchError((error: any) => of({
          loading: false,
          error: error,
          data: []
        })
        ),
        startWith({
          loading: true,
          error: null,
          data: []
        })
      )
  }


  // getCanonSearchList(params:queryParams){
  //   return this.verificationService.getCanonSearchList(params.companyName,params.country,params.easyNumber,params.type)
  //   .pipe(
  //     map((response:any)=>({
  //       data:response,
  //       loading:false,
  //       error:null
  //     })),
  //     catchError((error:any)=>of({
  //       data:[],
  //       loading:false,
  //       error:error
  //     })),
  //     startWith({
  //       loading:true,
  //       error:null,
  //       data:[]
  //     })
  //   )
  // }

  selectRecord(record: any): void {
    this.selectedRecord = record;
  }

  confirmMapping(): void {
    console.log('mapping confirmed from canon search in verification module ')
    this.mapToRecord.emit(this.selectedRecord);
    //  this.verificationTransferService.sendRecordToVerification(this.data,this.selectedRecord);
    this.dialogRef.close(this.selectedRecord);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onCloseDialog() {
    this.dialogRef.close();
  }

  onCountryChange(country: string) {
    this.queryParameters$.next({
      ...this.queryParameters$.value,
      country: country
    })
  }

  onCompanyTypeChange(type: string) {
    this.queryParameters$.next({
      ...this.queryParameters$.value,
      type: type
    })
  }

  onCompanyNameChange(name: string) {
    this.queryParameters$.next({
      ...this.queryParameters$.value,
      companyName: name
    })
  }

  // createCanonRequest(){
  //   this.createRequest.emit(this.data);
  //   // this.dialogRef.close();
  //   //  this.router.navigate(['/verification/canon-form'],{
  //   //   state:{
  //   //     record:this.data.record,
  //   //     mode:'create'
  //   //   }
  //   // })
  // }
}
